import axios from 'axios'

const http = axios.create({
  baseURL: `https://${
    /test|localhost|^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/i.test(
      window.location.hostname
    )
      ? 'testcdn'
      : 'cdn'
  }.xiaobaoxiu.cn`
})
http.interceptors.response.use(res => {
  return res.data
})

export default http
